// Based on
// npx @svgr/cli --icon --typescript --replace-attr-values="#000=" --replace-attr-values="none=" src/components/AMSIcon/AMS_Icon.svg

import * as React from 'react'

export const AMSIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <g fill="" fillRule="evenodd">
                <circle fill="" cx={12} cy={12} r={12} />
                <path
                    d="M3.893 14.92l.437-1.203h2.297l.44 1.203h1.394L6.08 9.08H4.867L2.5 14.92h1.393zm2.38-2.178h-1.59l.79-2.186.8 2.186zm4.092 2.178v-1.596l-.131-2.752 1.711 4.348h.9l1.716-4.352-.13 2.756v1.596h1.314V9.08h-1.721L12.4 13.316 10.766 9.08H9.055v5.84h1.31zm8.83.08c.704 0 1.264-.144 1.68-.431.417-.288.625-.684.625-1.19 0-.454-.17-.834-.51-1.138-.342-.305-.884-.56-1.63-.766-.404-.113-.71-.233-.919-.361-.208-.129-.312-.288-.312-.478 0-.203.089-.367.266-.49.178-.125.427-.187.747-.187.332 0 .59.074.773.222.183.149.275.356.275.624h1.31c0-.35-.098-.663-.295-.939a1.9 1.9 0 00-.827-.64A3.076 3.076 0 0019.164 9c-.451 0-.858.07-1.22.209-.363.139-.641.332-.835.58-.193.246-.29.528-.29.843 0 .607.36 1.09 1.083 1.448.265.131.624.264 1.078.4.454.134.769.263.944.384a.6.6 0 01.262.524.554.554 0 01-.262.487c-.175.116-.418.174-.73.174-.838 0-1.257-.322-1.257-.966h-1.315c0 .377.106.708.317.995.21.286.517.51.92.675.4.165.846.247 1.335.247z"
                    fill="#FFF"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    )
}
